import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./supabase.types.js";

/**
 * Browser Supabase client (anon key). Respects RLS.
 * Only expose public-readable data via this client — service-role lives in
 * src/lib/supabase.ts and is server-only.
 */
let cached: SupabaseClient<Database> | null = null;

export function getBrowserClient(): SupabaseClient<Database> {
  if (cached) return cached;

  const url = import.meta.env.VITE_SUPABASE_URL?.trim();
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
  if (!url || !anonKey) {
    throw new Error(
      "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Set them in Vercel and redeploy."
    );
  }

  cached = createClient<Database>(url, anonKey, {
    auth: { persistSession: false, autoRefreshToken: false },
  });
  return cached;
}
